module.exports = __webpack_public_path__ + "media/images/tl/banner/vi-2-light-c8f19cbb78cd0d94aa3fc272289b1041.jpg";